import React from 'react';
import { TableForm } from './TableForm';
import { TableList } from './TableList';
import { TableExcelValidation } from './TableExcelValidation';

const tableRoutes = [
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/outlet-setting/:outletID/table`,
		},
		component: <TableList />,
	},
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/outlet-setting/:outletID/table/add`,
		},
		component: <TableForm />,
	},
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/outlet-setting/:outletID/table/excel-validation`,
		},
		component: <TableExcelValidation />,
	},
];

export default tableRoutes;
